export enum CountryIso2Code {
  GreatBritain = 'GB',
  Ireland = 'IE',
}
